@if (config) {
    <generic-list-manager [config]="config"></generic-list-manager>
}

<app-tpa-connection-wizard (reload)="reload()" #connectionWizard></app-tpa-connection-wizard>
